import React from 'react'
import PropTypes from 'prop-types'

import { Link as RouterLink } from 'react-router-dom'

import Link from '@mui/material/Link'

const CamperSessionLink = props => {
  const { camper, camperSession } = props

  const { usedDays, session, buc } = camperSession

  if (!usedDays && !buc) {
    return null
  }

  const camperSessionPath = `/campers/${camper.id}/sessions/${session.id}`

  return (
    <Link
      sx={{ ml: 1, fontSize: '0.875rem' }}
      component={RouterLink}
      to={camperSessionPath}
      underline='always'
    >
      {usedDays > 0 ? 'show attendances »' : 'show upcoming care »'}
    </Link>
  )
}

CamperSessionLink.propTypes = {
  camper: PropTypes.object.isRequired,
  camperSession: PropTypes.object.isRequired
}

export default CamperSessionLink
